export default "__VITE_ASSET__DDdt71gl__"